import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import common from '../../styles/common.js';
import { generate } from '../../router.js';
import { Routes } from '../../routes.js';

@customElement('swd-hero')
class SwdHero extends LitElement {
  static styles = [
    common,
    css`
      :host {
        min-height: 500px;
        overflow: hidden;
        position: relative;
        display: block;
        background: var(--hero-background);
      }

      ::slotted(h1) {
        animation: slide-fade-in-right 1s;
      }

      ::slotted(p) {
        animation: faded .5s, slide-fade-in-right .5s .5s;
      }
      
      #hero-wrapper {
        max-width: 100%;
        position: absolute;
        inset: 40px 0 0;
      }

      #hero-background {
        min-width: 450px;
        height: auto;
        right: 0;
        position: absolute;
        min-height: 100%;
      }

      #hero-content {
        color: #000;
        min-height: 500px;
        padding: 0 40px 135px;
        writing-mode: vertical-lr;
        z-index: 2;
      }

      #hero-content-wrapper {
        position: relative;
        margin: 50% 0 0;
        transform: translateY(-50%);
        max-width: 600px;
        display: inline-block;
        writing-mode: initial;
        background: rgba(255, 255, 255, .8);
        padding: 16px 24px;
        border-radius: 12px;
      }
      
      :host([tall]) #hero-content {
        align-items: flex-end;
        display: flex;
      }

      :host(:not([tall])) #hero-content {
        display: flex;
        align-items: center;
      }
      
      #hero-content > picture {
        display: none;
        animation: faded .5s, slide-fade-in-left .5s .5s;
      }
      
      #financing {
        line-height: 40px;
        font-size: 24px;
        font-weight: bold;
        color: #FFF;
        background: var(--bs-primary);
        text-align: center;
        max-width: 100vw;
      }

      @media (min-width: 576px) {
        :host([tall]),
        :host([tall]) #hero-content {
          min-height: 800px;
        }
        
        #hero-content > picture {
          position: absolute;
          display: inline;
          bottom: 0;
          right: 0;
          z-index: 0;
        }

        :host([tall]) #hero-background {
          min-width: 1920px;
        }
      }
      
      @media (max-width: 992px) {
        #hero-content > picture {
          opacity: .5;
        }
      }
      
      @media (max-width: 650px) {
        #financing span {
          display: block;
        }

        #hero-wrapper {
          inset: 80px 0 0;
        }
      }

      @media (min-width: 1200px) {
        :host([tall]) #hero-content {
          position: relative;
          z-index: 1;
        }

        :host([tall]) #hero-content > picture:after {
          content: "";
          background: rgba(255, 255, 255, .5);
          position: absolute;
          inset: 0 0 0 100%;
          width: 5000px;
        }
      }
    `
  ];

  @property({ type: Boolean, reflect: true })
  tall = null;

  @property({ type: String })
  srcset;

  @property({ type: String })
  src;

  @property({ type: String })
  sizes;

  @property({ type: String })
  heroImageSrc;

  @property({ type: String })
  heroImageAlt;

  render() {
    return html`
      <div id="financing">
        <span>Financing now available!</span>
        <span><swd-a href=${generate(Routes.SERVICE)}>Request a Quote Today!</swd-a></span>
      </div>
      ${this.srcset ? html`
        <div id="hero-wrapper">
          <img
            id="hero-background"
            srcset=${this.srcset}
            src=${this.src}
            sizes=${this.sizes}
            alt="Hero image"
          >
        </div>
      ` : ''}
      <div id="hero-content" class="container-md">
        ${this.tall && this.heroImageSrc ? html`
          <picture>
            <img src=${this.heroImageSrc} alt=${this.heroImageAlt || ''}>
          </picture>
        ` : ''}
        <div id="hero-content-wrapper">
          <slot></slot>
        </div>
      </div>
    `;
  }
}